import { Widget } from '@automation-suite/shared-clients-widget-variant';
import { cloneDeep, isEqual } from 'lodash';

let previousProps: Record<string, unknown> | undefined;

export function shouldRecreateWidget(
  currentProps: Record<string, unknown>,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  widget?: Widget<any, any, any, any>
): boolean {
  if (previousProps && isEqual(previousProps, currentProps) && widget?.state !== 'DESTROYED') {
    return false;
  }

  previousProps = cloneDeep(currentProps);
  return true;
}
